import React, { useEffect, useState } from 'react';
import API from '../Api';
import { useNavigate } from 'react-router-dom';
import SubPageHeader from '../../components/common/SubPageHeader';

// Assets
import mudraMainImg from '../../assets/images/MudraPic-removebg-preview.png'; 

const MudraAbhyas = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMudraData = async () => {
      try {
        const res = await API.get('get-content/Mudra/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading mudra data:", err);
      }
    };
    fetchMudraData();
  }, []);

  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };
  const defaultSteps = [
    "1) Importance of MUDRAS", "2) History & MUDRAS Basics", "3) TATVA MUDRAS",
    "4) PRANIC MUDRAS", "5) THERAPEUTIC MUDRAS 1", "6) THERAPEUTIC MUDRAS 2",
    "7) THERAPEUTIC MUDRAS 3", "8) SUMMARY"
  ];
  return (
    <div className="bg-white min-h-screen">
      <SubPageHeader title="Mudra Abhyas" subtitle="Build a Community with Immunity" />

      {/* 1. Introduction Section - Reduced Gap */}
      <section className="py-16 container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-8"> 
          
          {/* Image Side - Smaller Size */}
          <div className="flex-shrink-0" data-aos="fade-right">
            <div className="relative max-w-[280px] md:max-w-[320px]"> 
              <img 
                
                src={`${resolveImageUrl(data.mudra_main_img, mudraMainImg)}?t=${new Date().getTime()}`} 
                alt="Hasta Mudra" 
                className="w-full h-auto object-contain"
              />
              
              
              <div className="absolute -bottom-4 -right-2 bg-[#54a50f] text-white p-4 rounded-xl hidden md:block shadow-lg">
                <p className="text-xl font-bold leading-none italic">
                  {data.healing_percent || "100%"}
                </p>
                <p className="text-[10px] uppercase tracking-tighter">
                  {data.healing_label || "Natural Healing"}
                </p>
              </div>
            </div>
          </div>

          {/* Text Side - Professional Content */}
          <div className="max-w-2xl" data-aos="fade-left">
            <h2 className="text-3xl md:text-4xl font-bold text-[#032167] mb-4 leading-tight">
              {data.title || "Unlock Your Inner Energy"} <br /> 
              <span className="text-[#54a50f]">{data.subtitle || "Through Mudra Science"}</span>
            </h2>
            
            <div className="space-y-4 text-gray-700 text-base md:text-lg leading-relaxed">
              <p>{data.p1 || "The ancient science of hand gestures..."}</p>
              <p>{data.p2 || "The different combinations of our fingers..."}</p>
              <p className="italic font-medium text-[#032167]">
                {data.quote || '"Every person can practice mudras..."'}
              </p>
            </div>

            {/* Quick Benefits Grid -  */}
            <div className="grid grid-cols-2 gap-x-2 gap-y-3 mt-8">
              {[
                data.benefit_1 || "Stress Relief",
                data.benefit_2 || "Better Immunity",
                data.benefit_3 || "Mental Focus",
                data.benefit_4 || "Internal Balance"
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center text-[#032167] text-[10px]">✓</div>
                  <span className="font-medium text-sm md:text-base">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 2. Course Roadmap Section */}
      <section className="bg-[#f8fbff] py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-[#032167] mb-2">{data.curriculum_title || "Course Curriculum"}</h3>
              <p className="text-gray-500">{data.curriculum_subtitle || "A systematic journey to understand and practice Mudras daily."}</p>
              <div className="w-20 h-1 bg-[#54a50f] mx-auto mt-4"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {defaultSteps.map((defaultStep, i) => (
                <div key={i} className="bg-white p-5 rounded-xl shadow-sm border-l-4 border-[#032167] hover:border-[#54a50f] transition-all">
                  <span className="text-[#032167] font-bold">
                    {data[`course_step_${i + 1}`] || defaultStep}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-12 p-6 bg-blue-50 rounded-2xl border border-blue-100 text-center">
              <p className="text-[#032167] font-medium">
                {data.curriculum_note || "Note: Practice Mudras along with the medication you are prescribed. Study the course in detail and prepare a set of MUDRAS as per your body type and ailments."}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Final CTA */}
      <section className="py-20 text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#032167] mb-6 ">
            "BUILD A COMMUNITY WITH IMMUNITY"
          </h2>
          
          <button 
            type="button" 
            onClick={() => navigate('/TGSH/login')} 
            className="bg-[#54a50f] hover:bg-[#032167] text-white font-bold py-4 px-12 rounded-full transition-all duration-300 ease-in-out shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95 text-lg tracking-wide"
          >
            Login To Continue
          </button>
        </div>
      </section>
    </div>
  );
};

export default MudraAbhyas;